exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/css-loader?{"sourceMap":false,"importLoaders":1}!H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/postcss-loader?{"ident":"postcss"}!H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2